import { UpgradeIds } from '../enums'
import type { UpgradeFactoryInput } from '../../../../types/UpgradeFactoryInput'
import { DepartmentIds } from '../../departments'
import TwoExponentRiseFactory from './factory'
import departments from '../../departments'

const creatives: UpgradeFactoryInput[] = [
	{
		name: 'Transparent Packaging',
		description:
			'Use completely clear packaging for all sensitive materials. Nobody will suspect a thing!'
	},
	{
		name: 'Loud Delivery Service',
		description:
			'Equip all delivery vehicles with maximum volume sirens and disco lights.'
	},
	{
		name: 'Public Transit Routes',
		description:
			'Transport all sensitive materials via public buses. The schedule is terrible!'
	},
	{
		name: 'Quantum Cargo',
		description:
			'Packages now exist in multiple locations until observed. Usually the wrong ones.'
	},
	{
		name: 'Time-Displaced Shipping',
		description:
			"Deliver packages before they're sent. The paperwork is a nightmare."
	},
	{
		name: 'Parallel Universe Logistics',
		description:
			'Ship items through parallel universes where all addresses are backwards.'
	},
	{
		name: 'Void Shipping',
		description:
			'Send packages through the void. Delivery times are theoretical at best.'
	}
]

const array = TwoExponentRiseFactory(
	creatives,
	DepartmentIds['Smuggling Network'],
	departments[DepartmentIds['Smuggling Network']].basePrice * 3,
	UpgradeIds.SmnExponent1
)

export default array
